import { QuestionCircleOutlined } from '@ant-design/icons';
import { Switch, Tooltip } from '@idaho-aeyc/ui-kit';
import { ToggleWrapper } from './ActiveFilterToggle.styles';
import { TActiveFilterToggleProps } from './ActiveFilterToggle.types';

const ActiveFilterToggle = ({
  checked,
  onChange,
  label,
  tooltipText,
  'data-cy': dataCy,
}: TActiveFilterToggleProps) => {
  return (
    <Tooltip title={tooltipText}>
      <ToggleWrapper data-cy={dataCy}>
        <QuestionCircleOutlined className="icon-question" />
        <span className="label-text">{label}</span>
        <Switch
          checked={checked}
          onChange={onChange}
          size="default"
          checkedChildren="Yes"
          unCheckedChildren="No"
        />
      </ToggleWrapper>
    </Tooltip>
  );
};

export default ActiveFilterToggle;
